// =====================================================================
// BoardBackgroundDialog (Quadros PRO / S60) — fundo do quadro (Trello-like):
// IMAGEM personalizada (wallpaper) · gradiente · cor sólida. Salva em
// board.background (updateBoard) ou via upload (POST /boards/:id/background).
// =====================================================================
import React, { useState, useRef } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, CircularProgress } from "@material-ui/core";
import { toast } from "react-toastify";
import { updateBoard, uploadBoardBackground, boardErrorMessage, BOARD_BACKGROUNDS, BOARD_GRADIENTS } from "../../services/boardService";

const BoardBackgroundDialog = ({ open, board, onClose, onSaved }) => {
  const cur = board && board.background;
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const apply = async (bg) => {
    if (!board) return;
    try {
      await updateBoard(board.id, { background: bg });
      onSaved && onSaved();
      onClose && onClose();
    } catch (e) { toast.error(boardErrorMessage(e)); }
  };

  const handleUpload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (fileRef.current) fileRef.current.value = "";
    if (!file || !board) return;
    setUploading(true);
    try {
      await uploadBoardBackground(board.id, file);
      toast.success("Fundo personalizado aplicado.");
      onSaved && onSaved();
      onClose && onClose();
    } catch (err) { toast.error(boardErrorMessage(err)); }
    finally { setUploading(false); }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Fundo do quadro</DialogTitle>
      <DialogContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="caption" color="textSecondary">Imagem personalizada (wallpaper)</Typography>
          <Button size="small" color="primary" disabled={uploading}
            startIcon={uploading ? <CircularProgress size={14} /> : null}
            onClick={() => fileRef.current && fileRef.current.click()}>Enviar imagem</Button>
          <input ref={fileRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleUpload} />
        </Box>
        {cur === "custom" ? <Typography variant="caption" style={{ color: "#2e7d32" }}>✓ usando imagem personalizada</Typography> : null}

        <Box mt={1.5}><Typography variant="caption" color="textSecondary">Gradientes</Typography></Box>
        <Box display="flex" style={{ gap: 8, flexWrap: "wrap", marginTop: 6, marginBottom: 12 }}>
          {BOARD_GRADIENTS.map((g) => (
            <div key={g.key} onClick={() => apply(g.key)} title={g.key}
              style={{ width: 60, height: 40, borderRadius: 6, cursor: "pointer", backgroundImage: g.css,
                border: cur === g.key ? "3px solid #000" : "2px solid #fff", boxShadow: "0 0 0 1px #ccc" }} />
          ))}
        </Box>
        <Typography variant="caption" color="textSecondary">Cores</Typography>
        <Box display="flex" style={{ gap: 8, flexWrap: "wrap", marginTop: 6 }}>
          {BOARD_BACKGROUNDS.map((c) => (
            <div key={c} onClick={() => apply(c)} title={c}
              style={{ width: 40, height: 40, borderRadius: 6, cursor: "pointer", background: c,
                border: cur === c ? "3px solid #000" : "2px solid #fff", boxShadow: "0 0 0 1px #ccc" }} />
          ))}
          <div onClick={() => apply("")} title="Sem fundo"
            style={{ width: 40, height: 40, borderRadius: 6, cursor: "pointer", background: "#fafafa",
              border: !cur ? "3px solid #000" : "1px solid #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#666" }}>
            nenhum
          </div>
        </Box>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Fechar</Button></DialogActions>
    </Dialog>
  );
};

export default BoardBackgroundDialog;
